import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Primitive"], {
        "data-slot": "sidebar-menu-sub-button",
        "data-sidebar": "menu-sub-button",
        as: $props.as,
        "as-child": $props.asChild,
        "data-size": $props.size,
        "data-active": $props.isActive,
        class: _normalizeClass($setup.cn('text-en-blue-500 ring-[var(--en-color-stroke)] flex h-[32px] hover:bg-en-blue-100 data-[active=true]:hover:bg-en-red-100 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-3 outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0', $props.size === 'sm' && 'text-xs', $props.size === 'md' && 'text-sm', 'group-data-[collapsible=icon]:hidden', $setup.props.class))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["as", "as-child", "data-size", "data-active", "class"]));
}
